/** The status pill and its "Ends in 3 days" line, or "Fix the schedule" when there is no status to show. */
import { campaignRelativeText, campaignStatus, type CampaignSchedule } from '@bonsai/shared';

import TicketSalesCampaignStatusPill from '../TicketSalesCampaignStatusPill';

export interface CampaignStatusLineProps {
  schedule: CampaignSchedule | null;
  now: Date;
}

export function CampaignStatusLine({ schedule, now }: CampaignStatusLineProps) {
  if (!schedule) {
    return (
      <span style={{ fontSize: 12, color: 'var(--nb-warn)', fontWeight: 700 }}>
        Fix the schedule
      </span>
    );
  }
  return (
    <>
      <TicketSalesCampaignStatusPill status={campaignStatus(schedule, now)} />
      <span style={{ fontSize: 12, color: 'var(--nb-muted)' }}>
        {campaignRelativeText(schedule, now)}
      </span>
    </>
  );
}
